import { GET_VEHICLE_SUCCESS, GET_VEHICLE_FAILURE } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_VEHICLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_VEHICLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
